import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import moment from 'moment-timezone';
import { setTimeout } from "timers";
import * as FileSaver from 'file-saver';

/**
 * Container component for the pharmacy page.
 * 
 */

class Support extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: true,
            shouldLoadData: true,
            searchText: "",
            selectedIssue: null,
            memberName: "",
            file: null,
            showSendMessageError: false,
            sendMessageError: "Sorry, we are unable to send your message at this time. Please try again later.",
            showSendMessageLoader: false,
            showErrorMessage: false
        };
        this.messageListRef = React.createRef();
        this.goToNewRequestPage = this.goToNewRequestPage.bind(this);
        this.formatDate = this.formatDate.bind(this);
        this.formatDisplayDate = this.formatDisplayDate.bind(this);
        this.saveFile = this.saveFile.bind(this);
        this.base64toBlob = this.base64toBlob.bind(this);
        this.clearNewMessage = this.clearNewMessage.bind(this);
        this.isTicketNew = this.isTicketNew.bind(this);
        this.getFileByteSize = this.getFileByteSize.bind(this);
        this.getMessagesMatchingSearchText = this.getMessagesMatchingSearchText.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Support.ComponentDidMount", new Date(), Tools.getURLPath());
        this.props.getSupportNotice();
        this.componentDidUpdate(this.props);
    }

    componentDidUpdate(prevProps) {
        const { hpIdentity, isFetching, swhp } = this.props;

        if (this.props.crmMessages && this.props.crmMessages !== prevProps.crmMessages) {
            this.setState({ showLoader: false }, () => {
                if (this.messageListRef.current) {
                    this.messageListRef.current.scrollTop = 9999; //TODO figure out a better way to scroll to the bottom
                }
            });

            if (!this.state.showSendMessageLoader && this.props.crmMessages.length > 0) {
                this.setState({ selectedIssue: this.props.crmMessages[0] });
            }

            if (!this.state.showLoader && document.getElementById("message-text-area").value) {
                this.clearNewMessage();
            }
        }

        if (this.props.error && !isFetching && this.props.error !== prevProps.error) {
            this.setState({ showLoader: false, showErrorMessage: true });
        }

        if (this.state.showSendMessageLoader && this.props.crmMessages !== prevProps.crmMessages) {
            this.setState({ showSendMessageLoader: false });
            this.props.crmMessages.map((ticket) => {
                if (ticket.caseid === this.state.selectedIssue.caseid) {
                    this.setState({ selectedIssue: ticket });
                }
            });
        } else if (this.state.showSendMessageLoader && !isFetching && this.props.error !== prevProps.error) {
            this.setState({ showSendMessageLoader: false, showSendMessageError: true });
        }

        if ((swhp || hpIdentity) && this.state.shouldLoadData && !isFetching) {
            var startDate = new Date();
            startDate.setYear(startDate.getFullYear() - 5);

            //setting the end date for the query range to the next day in case the full date-time value is applied in CRM
            //so that we can be sure to return any messages submitted after 12 AM today
            var endDate = new Date();
            endDate.setDate(endDate.getDate() + 1);
            var hpSourceSystem = swhp ? "Amisys" : "Health Rules";

            this.props.getCrmMessages(this.formatDate(startDate), this.formatDate(endDate), hpSourceSystem);

            var memberName = hpIdentity ? hpIdentity.firstName + " " + hpIdentity.lastName : "Member";
            this.setState({ shouldLoadData: false, memberName: memberName, hpSourceSystem: hpSourceSystem });
        }
    }



    goToNewRequestPage() {
        this.props.history.push('/newSupportRequest');
    }

    formatDate(date) {
        var mm = date.getMonth() + 1;
        var dd = date.getDate();

        return [date.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
        ].join('/');
    };

    formatDisplayDate(date) {
        var mm = date.getMonth() + 1;
        var dd = date.getDate();

        return [(mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
        ].join('/');
    }

    saveFile(base64String, fileName, mimetype) {
        var blob = this.base64toBlob(base64String, mimetype);
        FileSaver.saveAs(blob, fileName);
    }

    getFileByteSize(base64String) {
        var base64only = base64String.includes(";") ? base64String.split(";")[1].replace("base64,", "") : base64String;
        var lastTwoChars = base64only.length > 1 ? base64only.substring(base64only.length - 2) : "x=";
        var byteLength = lastTwoChars === "==" ? (base64only.length * (3 / 4)) - 2 : (base64only.length * (3 / 4)) - 1;
        return byteLength;
    }

    base64toBlob(base64Data, contentType) {
        contentType = contentType || '';
        var sliceSize = 1024;
        var byteCharacters = atob(base64Data);
        var bytesLength = byteCharacters.length;
        var slicesCount = Math.ceil(bytesLength / sliceSize);
        var byteArrays = new Array(slicesCount);

        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            var begin = sliceIndex * sliceSize;
            var end = Math.min(begin + sliceSize, bytesLength);

            var bytes = new Array(end - begin);
            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
    }

    clearNewMessage() {
        document.getElementById("message-text-area").value = "";
        this.setState({ file: null });
    }

    sendMessage() {
        this.setState({ showSendMessageError: false, showSendMessageLoader: true, sendMessageError: "Sorry, we are unable to send your message at this time. Please try again later." });
        var msgDesc = document.getElementById("message-text-area").value;

        if (msgDesc.trim().length === 0) {
            this.setState({ showSendMessageLoader: false, showSendMessageError: true, sendMessageError: "Please enter a more detailed message." });
            return;
        }

        if (this.state.file) {
            this.getBase64(this.state.file).then(base64 => {
                if ((this.getFileByteSize(base64) / 1000000) > 5) {
                    console.log("too big: ", this.getFileByteSize(base64));
                    this.setState({ sendMessageError: "Please select a file smaller than 5 MB.", showSendMessageLoader: false, showSendMessageError: true });
                    return;
                }

                if (base64.includes(";")) {
                    var mimetype = base64.split(";")[0].replace("data:", "");
                    var base64only = base64.split(";")[1].replace("base64,", "");
                    this.props.sendCrmMessage("Chat", msgDesc, this.state.file.name, base64only, this.state.selectedIssue.caseid, this.state.selectedIssue.title, mimetype, this.state.hpSourceSystem);
                }
            });
        }
        else {
            this.props.sendCrmMessage("Chat", msgDesc, "", "", this.state.selectedIssue.caseid, this.state.selectedIssue.title, "", this.state.hpSourceSystem);
        }
    }

    handleFileInput(event) {
        if (event && event.target && event.target.files && event.target.files.length === 1) {
            this.setState({ file: event.target.files[0] });
            return;
        }
    }

    isTicketNew(ticket) {
        if (ticket && ticket.messages.length > 0 && ticket.casestatus.toUpperCase() === "ACTIVE") {
            var isNew = true;
            ticket.messages.map((msg) => {
                if (!msg.createdbyportaluser) {
                    isNew = false;
                }
            });
            return isNew;
        }
        return false;
    }

    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    getMessagesMatchingSearchText() {
        if (!this.props.crmMessages) {
            return [];
        } else if (this.state.searchText === "") {
            return this.props.crmMessages
        } else {
            var filteredMessages = [];
            this.props.crmMessages.map((ticket) => {
                if (ticket.ticketnumber.toUpperCase().includes(this.state.searchText.toUpperCase()) || ticket.messagetype.toUpperCase().includes(this.state.searchText.toUpperCase())) {
                    filteredMessages.push(ticket);
                } else {
                    ticket.messages.map((msg) => {
                        if (msg.messagedescription.toUpperCase().includes(this.state.searchText.toUpperCase()) && !filteredMessages.includes(ticket)) {
                            filteredMessages.push(ticket);
                        }
                    });
                }
            });
            return filteredMessages;
        }
    }

    render() {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="hp-title">Member Support</div>
                    </div>
                    <hr className="full-width"></hr>
                    <div className="col-12 maxWidth-content">
                        <div className="support-wrapper">
                            <div className="support-container">
                                {this.state.showLoader ?
                                    <div id="support-spinner" className="spinner">
                                        <div className="bounce1" />
                                        <div className="bounce2" />
                                        <div className="bounce3" />
                                    </div>
                                    :
                                    <div className="row support-content">
                                        <div className={`get-messages-failed-banner ${this.state.showErrorMessage ? "" : "hidden"}`}>
                                            Sorry, we are not able to retrieve your Support Messages at this time. If you need assistance, please call 800.321.7947.
                                        </div>
                                        <div className="col-12 col-md-4 support-requests">
                                            <div className="support-new-request-container">
                                                <input type="button" onClick={() => this.goToNewRequestPage()} className="btn support-new-request-button" value="CREATE A NEW REQUEST" disabled={this.props.isReadOnly} />
                                            </div>
                                            <div className="support-request-search-container">
                                                <input type="text" id="support-search-text" className="text-input" placeholder="Search All Help Requests" value={this.state.searchText} onChange={(e) => { this.setState({ searchText: e.target.value }) }} />
                                                <div className="icon-search support-search-icon" />
                                            </div>
                                            <div className="support-card-list">
                                                {this.getMessagesMatchingSearchText().map((issue) => {
                                                    return (
                                                        <div key={`support-card-${issue.caseid}`} className={`support-card ${this.state.selectedIssue && this.state.selectedIssue.caseid === issue.caseid ? "support-card-selected" : ""} ${this.isTicketNew(issue) ? "support-card-new" : ""}`}
                                                            onClick={() => { this.setState({ selectedIssue: issue }); this.clearNewMessage(); }}
                                                        >
                                                            <div className="support-card-header">
                                                                <div className="support-card-id">
                                                                    ID {issue.ticketnumber}
                                                                </div>
                                                                <div className={`support-card-status ${issue.casestatus.toUpperCase() === "ACTIVE" ? "support-card-status-active" : "support-card-status-closed"}`}>
                                                                    {issue.casestatus.toUpperCase() === "ACTIVE" ? "ACTIVE" : "CLOSED"}
                                                                </div>
                                                            </div>
                                                            <div className="support-card-body">
                                                                <div className="support-card-body-title">
                                                                    {issue.title}
                                                                </div>
                                                                <div className="support-card-body-message-preview">
                                                                    {issue.messages[0].messagedescription}
                                                                </div>
                                                            </div>
                                                            <div className="support-card-footer">
                                                                <div className="support-card-date">
                                                                    {this.formatDisplayDate(new Date(issue.createdon))}
                                                                </div>
                                                                <div className="support-card-new-label">
                                                                    {this.isTicketNew(issue) ? "NEW" : ""}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        {this.state.selectedIssue ?
                                            <div className="col-12 col-md-8 support-thread-container">
                                                <div className="support-thread-header-container">
                                                    <div className="support-thread-header">
                                                        <div className="support-thread-header-top">
                                                            <div className="support-thread-title">
                                                                {this.state.selectedIssue.title}
                                                            </div>
                                                            <div className="support-thread-id">
                                                                Ticket ID {this.state.selectedIssue.ticketnumber}
                                                            </div>
                                                        </div>
                                                        <div className="support-thread-header-bottom">
                                                            <div className="support-thread-preview">
                                                                {this.state.selectedIssue.messages[0].messagedescription}
                                                            </div>
                                                            <div className="support-thread-date">
                                                                Created {this.formatDisplayDate(new Date(this.state.selectedIssue.createdon))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="support-thread-body-container">
                                                    <div className="support-thread-body">
                                                        <div ref={this.messageListRef} className="support-thread-message-list">
                                                            {this.state.selectedIssue.messages.map((msg) => {
                                                                return (
                                                                    <div key={msg.annotationid} className={`support-thread-message-block ${msg.createdbyportaluser ? "support-thread-user-message" : "support-thread-sc-message"}`}>
                                                                        <div className="support-thread-username">{msg.createdbyportaluser ? this.state.memberName : "Support Center"}</div>
                                                                        <div className="support-thread-messages">
                                                                            <div className={`support-thread-message-container ${msg.attachment && msg.attachment.length > 0 ? "" : "hidden"}`} onClick={() => { this.saveFile(msg.attachment, msg.filename, msg.mimetype) }}>
                                                                                <div className="support-thread-file">
                                                                                    <div className="support-thread-icon">
                                                                                        <div className="icon-archive" />
                                                                                    </div>
                                                                                    <div className="support-thread-file-info">
                                                                                        <div className="support-thread-file-name">{msg.filename}</div>
                                                                                        <div className="support-thread-file-size">{Math.ceil(this.getFileByteSize(msg.attachment) / 1000)} KB</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="support-thread-message-container">
                                                                                <div className="support-thread-message-text">
                                                                                    {msg.messagedescription}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="support-thread-message-date">
                                                                            {this.formatDisplayDate(new Date(msg.createdon))}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                        {this.state.showSendMessageLoader ?
                                                            <div id="support-form-spinner" className="spinner">
                                                                <div className="bounce1" />
                                                                <div className="bounce2" />
                                                                <div className="bounce3" />
                                                            </div>
                                                            : ""
                                                        }
                                                        <div className="support-thread-input">
                                                            <div className="support-thread-message-input">
                                                                <textarea id="message-text-area" name="message" className="large-message-input" placeholder={`${this.state.selectedIssue && this.state.selectedIssue.casestatus.toUpperCase() === "ACTIVE" ? "Enter a message" : "This ticket has been closed."}`} disabled={`${this.state.selectedIssue && this.state.selectedIssue.casestatus.toUpperCase() === "ACTIVE" ? "" : "disabled"}`} />
                                                            </div>
                                                            <div className="bold-text entered-style submit-error-container">
                                                                {this.state.showSendMessageError ? this.state.sendMessageError : ""}
                                                            </div>
                                                            <div className="support-message-buttons">
                                                                <div className={`support-file-upload-name ${this.state.file ? "" : "hidden"}`}>{this.state.file ? this.state.file.name : ""}</div>
                                                                <div className="support-file-upload-container">
                                                                    <input type="file" id="support-file-upload" onChange={(e) => this.handleFileInput(e)} style={{ "display": "none" }} />
                                                                    <div className="support-attach-file" onClick={() => document.getElementById("support-file-upload").click()}>
                                                                        <div className="icon-archive" />
                                                                    </div>
                                                                </div>
                                                                <div className="support-submit-container">
                                                                    <input type="button" className="btn support-send-message-button" value="SEND MESSAGE" onClick={() => { this.sendMessage() }} disabled={!(this.state.selectedIssue && this.state.selectedIssue.casestatus.toUpperCase() === "ACTIVE") || this.props.isReadOnly} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            : ""}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        error: state.healthPlanServices.error,
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        isFetching: state.healthPlanServices.isFetching,
        crmMessages: state.healthPlanServices.crmMessages,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCrmMessages: (startDate, endDate, hpSourceSystem) => dispatch({ type: types.HP_GET_CRM_MEMBER_MESSAGES_START, startDate: startDate, endDate: endDate, hpSourceSystem: hpSourceSystem }),
        sendCrmMessage: (msgType, msgDesc, fileName, attachment, caseId, title, mimetype, hpSourceSystem) => dispatch({ type: types.HP_SEND_CRM_MESSAGE_START, msgType: msgType, msgDesc: msgDesc, fileName: fileName, attachment: attachment, caseid: caseId, title: title, mimetype: mimetype, hpSourceSystem: hpSourceSystem }),
        getSupportNotice: () => dispatch({ type: types.HP_GET_SUPPORT_NOTIFICATION_START })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Support));
